define(
	'DC.Facets.ItemCell.View.Extension'
,   [
		'Facets.ItemCell.View',
        'underscore'
	]
,   function (
        FacetsItemCellView,
        _
	)
{
	'use strict';

    return _.extend(FacetsItemCellView.prototype, {
        getContext: _.wrap(FacetsItemCellView.prototype.getContext, function (fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            
            if(this.model && this.model.get('isItemGroup')){
                context.isItemGroup = true;
                context.itemId = this.model.get('itemid');
                context.url = '/product/item-group/'+this.model.get('id');
                context.showRating = false;
                context.isEnvironmentBrowser = false;
                //set thumbnail
                if(this.model.get('itemimage')){
                    context.thumbnail.url = this.model.get('itemimage');
                }
            }
            return context;
        })
    });
	
});
